var _path, _path2, _rect, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconExcel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66683 1.6665C4.20659 1.6665 3.8335 2.0396 3.8335 2.49984V13.4522C3.8335 13.9125 4.20659 14.2856 4.66683 14.2856H12.6668C13.1271 14.2856 13.5002 13.9125 13.5002 13.4522V6.51541C13.5002 6.47219 13.4834 6.43066 13.4533 6.39958L8.9272 1.71733C8.89579 1.68485 8.85255 1.6665 8.80736 1.6665H4.66683ZM2.8335 2.49984C2.8335 1.48731 3.65431 0.666504 4.66683 0.666504H8.80736C9.12364 0.666504 9.42637 0.794913 9.64619 1.02231L14.1723 5.70456C14.3826 5.92211 14.5002 6.21284 14.5002 6.51541V13.4522C14.5002 14.4647 13.6794 15.2856 12.6668 15.2856H4.66683C3.65431 15.2856 2.8335 14.4647 2.8335 13.4522V2.49984Z",
    fill: "#222729"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.10563 0.666504C9.34789 0.666504 9.54428 0.872661 9.54428 1.12697V5.59208C9.54428 5.67702 9.60999 5.74581 9.6909 5.74557L13.5604 5.73407C13.8027 5.73335 13.9996 5.93892 14.0003 6.19322C14.001 6.44753 13.8052 6.65427 13.5629 6.65499L9.69339 6.6665C9.127 6.66818 8.66699 6.18666 8.66699 5.59208V1.12697C8.66699 0.872661 8.86338 0.666504 9.10563 0.666504Z",
    fill: "#222729"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.3335,
    y: 6,
    width: 7.33333,
    height: 7.33333,
    rx: 1,
    fill: "#222729"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83306 7.3335L7.33301 12.0002L6.16629 12.0002L2.66634 7.3335L3.83306 7.3335Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83306 7.3335L7.33301 12.0002L6.16629 12.0002L2.66634 7.3335L3.83306 7.3335Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83306 12L7.33301 7.33333L6.16629 7.35601L2.66634 12L3.83306 12Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83306 12L7.33301 7.33333L6.16629 7.35601L2.66634 12L3.83306 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExcel);
export default __webpack_public_path__ + "static/media/icon-excel.8d4256a5c9b450d1588287a7f4b7c0a7.svg";
export { ForwardRef as ReactComponent };